import {Grid2 as Grid, Paper, TableContainer, Table, TableHead, TableRow, TableCell, Typography, TableBody} from '@mui/material';
import { SubvendorPaymentItem } from '../../../types/reports/subvendorPaymentItem';

interface Props {
   subVendorPayments?:SubvendorPaymentItem[];
   total?: string;
}

const SubvendorPaymentsScheduleTable = (props: Props): JSX.Element => {

    return (
        <Grid container spacing={1}>
         <TableContainer component={Paper}>
             <Table aria-label="subvendor payment table" size="small">
                 <TableHead>
                     <TableRow>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Date
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Vendor
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Subvendor/Address
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                                 variant={'subtitle2'}
                                 fontWeight={600}>
                                Payment to Subvendor
                             </Typography>
                         </TableCell>
                         <TableCell>
                             <Typography
                             variant={'subtitle2'}
                             fontWeight={600}>
                                Purpose
                             </Typography>
                         </TableCell>
                     </TableRow>
                 </TableHead>
                 <TableBody>
                     {props.subVendorPayments?.map((payment) => (
                         <TableRow
                         key={payment.id}
                         sx={{
                             '&:last-child td, &:last-child th': { border: 0 },
                         }}
                         >
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {payment.date}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {payment.vendorName} 
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {payment.subvendorName} 
                                 </Typography>
                                 <Typography variant={'subtitle2'}>
                                     {payment.fullAddress} 
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {payment.amount}
                                 </Typography>
                             </TableCell>
                             <TableCell>
                                 <Typography variant={'subtitle2'}>
                                     {payment.description}
                                 </Typography>
                             </TableCell>
                         </TableRow>
                    ))}
                 </TableBody>
             </Table>
         </TableContainer>
        </Grid>
    );
}

export default SubvendorPaymentsScheduleTable;